import axios from "axios";
import { API_BASE_URL } from "../constants";

export const sendContactQuery = async (formData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}api/contactqueries/create`,
      formData
    );

    return response.data;
  } catch (error) {
    console.error("Error sending contact query:", error);
    throw error;
  }
};

// GET: Retrieve all contact queries
export const getAllContactQueries = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}api/contactqueries/getall`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching contact queries:", error);
    throw error;
  }
};

export const deleteContactQuery = async (id) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}api/contactqueries/delete/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting contact query:", error);
    throw error;
  }
};
